import styled, { from } from 'theme';

export const AccountDetailsWrapper = styled.div`
  ${from('xlg')} {
    .company-details__key,
    .contact-information__key,
    .account-name__key {
      flex: 0 0 14rem;
    }
  }

  ${from('md')} {
    .company-details__key,
    .contact-information__key,
    .account-name__key {
      align-self: center;
    }
  }

  .company-details__value,
  .contact-information__value,
  .account-name__value {
    font-size: ${props => props.theme.variables.fonts.size.base};
    color: ${props => props.theme.variables.customColors.lightNavy};
  }
`;
